import Collapse from '@mui/material/Collapse';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { select } from '@ps/web-core-store';
import { InfoIcon, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import RegulatoryCheckboxes from '@swf/components/RegulatoryCheckboxes/RegulatoryCheckboxes';
import ArrowIcon from '@swf/core/assets/icons/arrow.svg';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTCLI_Further_TXCs,
  TXTCLI_General_Terms,
  TXTCLI_The_following_individuals_are__ELL,
  TXTCLI_The_following_individuals_are__ELL_1,
  TXTCLI_The_following_individuals_are__ELL_2,
  TXTCLI_Your_terms,
  TXTWCL_For_your_protection_you_can_ma_ELL_2
} from './RMFTermsOfService.messages.json';
import { active, arrow, arrowContainer, infoBox, infoText } from './RMFTermsOfService.scss';

const RMFTermsOfService = () => {
  const [infoExpanded, setInfoExpanded] = useState<boolean>(false);

  const variant = 'rmf';
  const site = useSelector(select.cms.getSiteId);

  return (
    <Container
      page={RMFTermsOfService}
      headerProps={{
        title: <Translation {...TXTCLI_Your_terms} />
      }}
      pageTopTitle={<Translation {...TXTCLI_General_Terms} />}
    >
      <fieldset>
        <RegulatoryCheckboxes variant={variant} />
        {[Sites.USMI, Sites.US_NJ, Sites.US_PA].includes(site) && (
          <>
            <div className={infoBox} onClick={() => setInfoExpanded(!infoExpanded)}>
              <InfoIcon />
              <div className={infoText}>
                <Translation {...TXTCLI_Further_TXCs} />
              </div>
              <div className={arrowContainer}>
                <ArrowIcon className={classNames(arrow, { [active]: infoExpanded })} />
              </div>
            </div>
            <Collapse in={infoExpanded}>
              {site === Sites.USMI && (
                <Translation tagName="p" {...TXTCLI_The_following_individuals_are__ELL} />
              )}
              {site === Sites.US_NJ && (
                <Translation tagName="p" {...TXTCLI_The_following_individuals_are__ELL_1} />
              )}
              {site === Sites.US_PA && (
                <Translation tagName="p" {...TXTCLI_The_following_individuals_are__ELL_2} />
              )}
              <Translation tagName="p" {...TXTWCL_For_your_protection_you_can_ma_ELL_2} />
            </Collapse>
          </>
        )}
      </fieldset>
      <CTAButton />
    </Container>
  );
};

RMFTermsOfService.displayName = 'RMFTermsOfService';

export default RMFTermsOfService;
